import { isNumber, tryConvertFloat } from '../services/numberConverterService';
function getComparable(value) {
  return typeof value === 'string' ? value.toLowerCase() : value;
}
function valueEndsWith(value, expected) {
  var start = value.length - expected.length;
  if (start < 0) return false;
  return expected === value.substring(start);
}
function matchesOperation(rule) {
  var value = getComparable(rule.value);
  var expected = getComparable(rule.expected);
  var operation = rule.operation;
  switch (operation) {
    case 'isnot':
      return value !== expected;
    case '>':
      if (!isNumber(tryConvertFloat(value)) || !isNumber(tryConvertFloat(expected))) return false;
      return tryConvertFloat(value) > tryConvertFloat(expected);
    case '<':
      if (!isNumber(tryConvertFloat(value)) || !isNumber(tryConvertFloat(expected))) return false;
      return tryConvertFloat(value) < tryConvertFloat(expected);
    case 'contains':
      return value.indexOf(expected) >= 0;
    case 'starts_with':
      return value.indexOf(expected) === 0;
    case 'ends_with':
      return valueEndsWith(value, expected);
    case 'is':
    default:
      return value === expected;
  }
}

/**
 * @param {[]} rules
 * @param {{[logicType]: string, [elementsToMatch]: number}} options
 */
export default (function (rules) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      logicType: 'all'
    },
    _ref$logicType = _ref.logicType,
    logicType = _ref$logicType === void 0 ? 'all' : _ref$logicType,
    _ref$elementsToMatch = _ref.elementsToMatch,
    elementsToMatch = _ref$elementsToMatch === void 0 ? 1 : _ref$elementsToMatch;
  var matches = rules.reduce(function (total, rule) {
    if (matchesOperation(rule)) return total + 1;
    return total;
  }, 0);
  return logicType === 'all' && matches === rules.length || logicType === 'any' && matches >= elementsToMatch;
});